module.exports = __webpack_public_path__ + "static/media/MT103.b5f982bb.svg";